import React from 'react'
import Info from './info.js';

function Panel({children,caption,open,setOpen,width,info,url,height='700px'}){
    const stl={minWidth:(width-4)+'px',maxWidth:width*2-8+'px',display:'inherit',flexDirection:'inherit',flexShrink:'0',margin:'inherit',overflowX:'hidden',overflowY:'hidden',transition:'max-height .3s cubic-bezier(0, 0, 1, 1) 50ms'}
    if(open) {stl.maxHeight=height;stl.overflowY='visible';stl.overflowX='visible'}
    else {stl.maxHeight='20px'}
    let inf=null
    if(info) inf=<Info info={info} url={url} />
    if(caption) return(
        <div className={open?'':'no-print'} style={stl}>
            <div style={{display:'flex',alignItems:'center',overflow:open?'hidden':'unset'}}>
                <div style={{width:'10px',height:'1px',background:'#00000044',marginRight:'5px',marginTop:'2px'}} onClick={()=>setOpen(!open)} />
                <div style={{fontWeight:'600',cursor:'pointer'}} onClick={()=>setOpen(!open)}>{caption}{inf}</div>
                <div style={{width:'10px',height:'1px',background:'#00000044',marginLeft:'5px',marginTop:'2px',flexGrow:'10'}} onClick={()=>setOpen(!open)} />
                <div className='no-print' style={{padding:'6px 0px',width:'16px',writingMode:'vertical-lr',cursor:'pointer',color:'#00000044',fontSize:'large'}} onClick={()=>setOpen(!open)}>{open?'\u{00AB}':'\u{00BB}'}</div>
            </div>
            {children}
        </div>
    )
    else return(
        <div className={open?'':'no-print'} style={stl}>
            <div style={{display:'flex',alignItems:'center',overflow:open?'hidden':'unset'}} onClick={()=>setOpen(!open)}>
                <div style={{width:'10px',height:'1px',background:'#00000044',marginLeft:'5px',marginTop:'2px',flexGrow:'10'}} />
                <div className='no-print' style={{padding:'6px 0px',width:'16px',writingMode:'vertical-lr',cursor:'pointer',color:'#00000044',fontSize:'large'}}>{open?'\u{00AB}':'\u{00BB}'}</div>
            </div>
            {children}
        </div>
    )
}
export default Panel